// header fixed on scroll
$(document).ready(function () {

  // Product gallery image zoom
  if($('.image-zoom').length > 0){
    $('.image-zoom')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
  }
  
  $(".my-cart").click(function () {
    //updateCartDrawer();
    $(".cart-box").addClass("cart-display");
  });
  $(".cart-box .fa-times").click(function () {
    $(".cart-box").removeClass("cart-display");
  });

  $(".tab-menu-open").click(function () {
    $(".nav-menu").addClass("tab-menu-display");
    $(".nav-menu").removeClass("nav-menu-none");
    $("body").addClass("sm-body-scrollbar");
    //document.querySelector(".color-overlay").style.display = "block";
  });

  $(".cross-icon").click(function () {
    $(".nav-menu").addClass("nav-menu-none");
    $(".nav-menu").removeClass("tab-menu-display");
    $("body").removeClass("sm-body-scrollbar");
    //document.querySelector(".color-overlay").style.display = "none";
  });

  /*$(".product-bookmarks a").click(function(e) {
      e.preventDefault();
      var id= $(this).attr('href');
      var $id = $(id);
      // top position relative to the document
      var pos = $id.offset().top - 150;
      // animated top scrolling
      $('body, html').animate({scrollTop: pos},1000);
  })*/

  $(".bookmark1").click(function() {
      $('html,body').animate({
          scrollTop: $("#pdp-long-description").offset().top - 150
      },700);
  });
  $(".bookmark2").click(function() {
      $('html,body').animate({
          scrollTop: $("#pdp-specifications").offset().top - 150
      },700);
  });
  $(".bookmark3").click(function() {
      $('html,body').animate({
          scrollTop: $("#pdp-reviews").offset().top - 150
      },700);
  });
  
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#scroll").fadeIn();
    } else {
      $("#scroll").fadeOut();
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
  $(".searchbar").click(function () {
        document.getElementById("searchBlockSmall").style.width = "100%";
        var overlay = jQuery('<div id="overlay"> </div>');

        overlay.appendTo('.page-container');
        $("#searchBlockSmall").css('z-index','22333');
  });
  $(document).mouseup(function(e) {
    var container = $(".cart-box,.my-cart");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".cart-box").removeClass("cart-display");
    }
  });
  
  /*---- carousel css - To Fix overlap text issue when click next & previous slide---   */
  $('.carousel').on('slide.bs.carousel', function () {
   $('.carousel-control').addClass('disabled');
  });

  $('.carousel').on('slid.bs.carousel', function () {
    $('.carousel-control').removeClass('disabled');
  });

});

// search open block
function openNav() {
  document.getElementById("searchBlock").style.width = "100%";
}

function closeNav() {
  document.getElementById("searchBlockSmall").style.width = "0";
  document.getElementById("searchBlock").style.width = "0";
  $('#overlay').remove();
}

//quantity counter code
$(document).on("click", ".ajax-cart-item__minus-quantity", function (e) {
  decrementValue(e);
});
$(document).on("click", ".ajax-cart-item__add-quantity", function (e) {
  incrementValue(e);
});
$(document).on("click", ".cart-dropdown-remove .remove", function (e) {
  setTimeout(function() {
    updateCartDrawer();
  }, 1000);
});

function incrementValue(e) {
  e.preventDefault();
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var currentVariant = $(e.target).attr("data-variant");

   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: currentVal + 1,
          id: currentVariant
      },
      success: function(cart) {
        if (cart.total_price > 5000) {
          // Update the shipping message
          $('.shipping-message').html('<p class="success">This order qualifies for <strong>FREE Standard Shipping</strong>!</p>');
        } else {
          // Update the shipping message
          $('.shipping-message').removeClass("success");
          $('.shipping-message').html('<p>Just add £' + (5000 - cart.total_price)/100 + ' to this order to qualify for Free Standard Shipping.</p>');
        }
        setTimeout(function() {
          updateCartDrawer();
        }, 1000);
      }
  });

  if (!isNaN(currentVal)) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal + 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}
function decrementValue(e) {
  e.preventDefault();
  
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var currentVariant = $(e.target).attr("data-variant");

  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: currentVal - 1,
          id: currentVariant
      },
      success: function(cart) {
        if (cart.total_price > 5000) {
          // Update the shipping message
          $('.shipping-message').html('<p class="success">This order qualifies for <strong>FREE Standard Shipping</strong>!</p>');
        } else {
          // Update the shipping message
          $('.shipping-message').removeClass("success");
          $('.shipping-message').html('<p>Just add £' + (5000 - cart.total_price)/100 + ' to this order to qualify for Free Standard Shipping.</p>');
        }
        setTimeout(function() {
          updateCartDrawer();
        }, 1000);
      }
  });
  
  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal - 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}

$(document).ready(function () {
  $(".accordion-button").click(function () {
    $(this).addClass("Hello");
    $(this).toggleClass("bluecolor");
  });
});
$(function () {
      $('.lazy').Lazy();
}); 
// filter for mobile device
function openFilter() {
  document.getElementById("filterOption").style.width = "100%";
}

function closeFilter() {
  document.getElementById("filterOption").style.width = "0";
}
document.addEventListener("DOMContentLoaded", function () {
      /////// Prevent closing from click inside dropdown
      document.querySelectorAll('.dropdown-menu').forEach(function (element) {
        element.addEventListener('mouseover', function (e) {
          e.stopPropagation();
        });
      })
    
    });
    // DOMContentLoaded  end
var preloader = document.getElementById('loader');
 
document.addEventListener('DOMContentLoaded', () => {
      updateCartDrawer();
  });
function updateCartDrawer()
    {
//       alert('updatecart');
      var html ='';
      var cart = CartJS.cart;      
      $('.cartelements').html('');

      jQuery.getJSON('/cart.js', function(cart) {
        var cnt = cart.items.length;
        var cart_list = [];

        if(cnt > 0 ){
          for (i = 0; i < cnt; i++) { 
            var cartitems = cart.items[i];
            var item_id = cart['items'][i]['id'];
            var total_price = cart['total_price']/100;
            var line_price = cart['items'][i]['price']/100;
            $('.total_price').html('Subtotal:<span>£'+ total_price.toFixed(2) +'</span>');
            var quantity = cart['items'][i]['quantity'];
            // html = '<div class="product-price p-2 cart-dropdown-product-wrap"><div class="cart-dropdown-image product-img"><img src="'+cartitems.featured_image.url+'" alt="'+cartitems.featured_image.alt+'" class="img-fluid"></div><div class="product-content cart-dropdown-title-price"><a href="'+cartitems.url+'"><h6>'+cartitems.title+'</h6></a><div class="price_qty_wrap cart-dropdown-giftwrap-qty"><p class="cart-dropdown-title-price">price: <span>$'+line_price.toFixed(2)+'</span></p><p class="cart-dropdown-giftwrap-qty qty">Qty: <span>'+cartitems.quantity+'</span></p></div><div id="extend-dropdown-cart-offer" data-extend-variant="'+ cartitems.variant_id +'" data-extend-quantity="'+cartitems.quantity+'"></div></div></div>';
            html = '<div class="product-price p-2 cart-dropdown-product-wrap"><div class="cart-dropdown-remove" ><a class="remove" data-cart-remove-id="' + item_id + '" href="/cart/change?line=' + cart.item_count + '&amp;quantity=0" data-product="'+cartitems.id+'" aria-label="Remove Item From Cart">x</a></div><div class="cart-dropdown-image product-img"><img src="'+cartitems.featured_image.url+'" alt="'+cartitems.featured_image.alt+'" class="img-fluid"></div><div class="product-content cart-dropdown-title-price"><a href="'+cartitems.url+'"><h6>'+cartitems.title+'</h6></a><div class="price_qty_wrap cart-dropdown-giftwrap-qty"><p class="cart-dropdown-title-price">price: <span>£'+line_price.toFixed(2)+'</span></p><p class="cart-dropdown-giftwrap-qty qty d-none">Qty: <span>'+cartitems.quantity+'</span></p></div><div id="extend-dropdown-cart-offer" data-extend-variant="'+ cartitems.variant_id +'" data-extend-quantity="'+cartitems.quantity+'"></div></div><div class="cart-dropdown-quantity" data-line="' + cart.item_count + '"><button role="button" type="button" class="cart-dropdown-arrow-up ajax-cart-item__add-quantity" aria-label="Increase Cart Quantity by 1" data-variant="' + item_id + '"></button><div class="cart-dropdown-qty-value"><input class="quantity-input ajax-cart-item__input-quantity  cart__qty-input" name="updates[]" id="updates_' + item_id + '" value="' + quantity + '" min="1" /></div><button type="button" role="button" class="cart-dropdown-arrow-down ajax-cart-item__minus-quantity" data-variant="' + item_id + '" aria-label="Decrease Cart Quantity by 1"></button></div></div>';
            cart_list.push(html);
          }
          $('.cartelements').html(cart_list.join(''));
          var item_count = cart.item_count;
          $('#CartCount').find('span').html(item_count);
          $('#mobile-CartCount').find('span').html(item_count);


          $('#cart-count-view').show();
          $('#mobile-count-view').show();
          
          $('.total-checkout').show();
          
          initializeCartOffer();

          if (cart.total_price > 5000) {
            // Update the shipping message
            $('.shipping-message').html('<p class="success">This order qualifies for <strong>FREE Standard Shipping</strong>!</p>');
          } else {
            // Update the shipping message
            $('.shipping-message').removeClass("success");
            $('.shipping-message').html('<p>Just add £' + (5000 - cart.total_price)/100 + ' to this order to qualify for Free Standard Shipping.</p>');
          }
          
        }
        else{
          $('.cartelements').html('<div class="text-center"><br /><h3 class="my-5">No item found in your cart.</h3></div>');
          $('.total-checkout').hide();
          $('#cart-count-view').hide();
          $('#mobile-count-view').hide();
        }
       
      });      
    }
    function openCartDrawer()
    {
      window.scrollTo(0, 0);
      $(".my-cart").trigger("click");
    }
document.addEventListener('DOMContentLoaded', () => {
                              var API = new Mmenu("#menu", {
                              extensions: ["theme-light", "position-front", "position-left" , "border-none"],
                              navbar: { title: "Menu" },
                              navbars: [true],
                              offCanvas: {
                              page: {
                              nodetype: "section"
                              }
                              }
                              },
                              {
                              searchfield: { clear: true }
                              });
    });
    //var API = $("#menu").data( "mmenu" );
    $(".cross-icon-mobile").click(function () {
      $('.body-event').removeClass('mm-wrapper--opened');
      $('#menu').removeClass('mm-menu--opened');
    });
    $('.body-event').on('click', '#mm-0', function () {
      $('.body-event').removeClass('mm-wrapper--opened');
      $('#menu').removeClass('mm-menu--opened');
    });
    document.addEventListener("shopify:section:load", function(event) {
      $('.lazy').Lazy();
      $(".slick", ".vertical-slider").slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        dots: false
      });
      document.addEventListener('DOMContentLoaded', () => {
                                var API = new Mmenu("#menu", {
                                extensions: ["theme-light", "position-front", "position-left" , "border-none"],
                                navbar: { title: "Menu" },
                                navbars: [true],
                                offCanvas: {
                                page: {
                                nodetype: "section"
                                }
                                }
                                },
                                {
                                searchfield: { clear: true }
                                });
    });
    });

    var maxHeight = -1;
    $('.vertical-slider .slick-slide').each(function() {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $('.vertical-slider .slick-slide').each(function() {
      if ($(this).height() < maxHeight) {
        // $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
      }
    });

    $('.main-img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      fade: true,
      autoplay: false,adaptiveHeight: true,
      autoplaySpeed: 4000,
      speed: 300,
      lazyLoad: 'ondemand',
      asNavFor: '.thumb-nav'
    });
    // Thumbnail/alternates slider for product page
    $('.thumb-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      centerPadding: '0px',
      asNavFor: '.main-img-slider',
      dots: false,
      centerMode: false,
      draggable: true,
      speed: 200,
      focusOnSelect: true,
    });
    $( document ).ready(function() {
      $(".toggle-more").click(function() {
        var elem = $(".toggle-more").text();
        if (elem == "More Features") {
          //Stuff to do when btn is in the read more state
          $(".toggle-more").text("Less Features");
          $("#pdp-feature-list ul li:gt(2)").slideDown();
		} else {
          //Stuff to do when btn is in the read less state
          $(".toggle-more").text("More Features");
          $("#pdp-feature-list ul li:gt(2)").slideUp();
		}
      });
      if ($('#pdp-feature-list > ul > li').length > 3) {
        $('.toggle-more').show();
      }
      else{
        $('.toggle-more').hide();
      }
      
    });
    /*$('body').on('click', '.fs-add-to-cart-button', function (e){  
        updateCartDrawer();
        return true;
  });*/
  window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {
    updateCartDrawer();
  });


     //start js code for desktop menu as samsung

    function handleClick(id, index){        
    let previousChild = document.getElementById(id).previousElementSibling;
      //previousChild.style.borderBottom = "none";
      $( "#"+id ).prev().css( "border-bottom", "none" );
      if(index !== "1"){
          let tabId = id;
          let value = tabId.split("-tab");
          let newId = value[0];
          $( "#"+newId ).css( "border-radius", "18px" );
          //document.getElementById(newId).style.borderRadius = "18px";
      }
    }

    function handleClose(id) {
     $('.dropdown-content').hide();
    }

    function handleHover(id) {
      $(".backpacks-value").addClass("default-opacity");
      $(".dropdown-content").css("display", "none");
      document.getElementById(id).style.display = "block";
    }

    function openSubMenu(id) {
        $(".default-opacity").removeClass("default-opacity");
        $(".right-arrow").addClass(id + "-arrow close");

        $(".active").removeClass("link-active-color");
        $("#" + id + "-link").addClass("link-active-color");

        $(".parent-li").removeClass("nav-li-design");
        $("#" + id + "-li").addClass("nav-li-design");

        $("#" + id + "-arrow").removeClass(id + "-arrow close");
        $("#" + id + "-arrow").addClass(id + "-arrow open");
        $("._listImage").addClass(id + "-value close");
        $("._listItem").addClass(id + "-value close");
        $("#" + id + "-list").removeClass(id + "-value close")
        $("#" + id + "-list").addClass(id + "-value open")
        $("#" + id + "-image").removeClass(id + "-value close")
        $("#" + id).addClass("addActiveColor");
    }

    $( ".grandchildlink" ).hover(function() {
      var imageid = $(this).data('image-handle')+'-image';
      $('.imageelementmenu').removeClass("showelement");
      $('.imageelementmenu').addClass("hideelement");
      //alert(imageid);
      $("#" + imageid).addClass("showelement");
      $("#" + imageid).removeClass("hideelement");
    });

    function closeSubMenu(id, id2) {
        $("#backpacks-list").addClass("default-opacity");
    }